import React, { useEffect, useState } from 'react';
import Sidebar from '../StudentSidebar/Sidebar';
import StudentNavbar from '../StudentNavbar/StudentNavbar';
import { Button } from 'react-bootstrap';
import Vector from '../../assets/images/png/Vector.png';
import Image from '../../Components/Reusable/Image';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import RoutesPath from '../../Utils/RoutesPath';
import SubmitButtonTwo from '../../Components/Reusable/Buttontwo';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import { handleApiErrors } from '../../Utils/Utils';
import { toast } from 'react-toastify';
import { CirclesWithBar, RotatingLines } from 'react-loader-spinner';
import parse from "html-react-parser";
import { PngImages } from '../../Utils/LocalImages';

const Mocktest = () => {
    const location = useLocation();
    const mockTestData = location.state || {}
    const { durationInMinutes } = mockTestData;
    const [initialTime, setInitialTime] = useState(durationInMinutes * 60);
    const [timeLeft, setTimeLeft] = useState(durationInMinutes * 60);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [activeTab, setActiveTab] = useState('');
    const [selectedSubjectId, setSelectedSubjectId] = useState(null);
    const { mockTest_id, package_id } = useParams();
    const navigate = useNavigate();
    const [subjects, setSubjects] = useState([]);
    const [allQuestions, setAllQuestions] = useState([]);
    const [subjectAnswers, setSubjectAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false)
    const [subjectProgress, setSubjectProgress] = useState({});
    const [loading, setLoading] = useState(true);
    const [loadingTwo, setLoadingTwo] = useState(false);
    const [alldata, setAllData] = useState([]);
    const [subjectQuestionsById, setSubjectQuestionsById] = useState([]);
    const [startTime, setStartTime] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [attemptedCount, setAttemptedCount] = useState(0);
    const [notAttemptedCount, setNotAttemptedCount] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);


    // Call this when starting the test
    useEffect(() => {
        const currentTime = new Date();
        // Extracting time in "HH:MM:SS" format
        // const timeString = currentTime.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour12: true });
        setStartTime(currentTime); // e.g., "13:53:45"
    }, []);  

    useEffect(() => {
        if (!startTime) return; // Wait until startTime is set

        const timerId = setInterval(() => {
            if (!startTime) return;

            const currentTime = new Date();
            const elapsedTime = Math.floor((currentTime - startTime) / 1000); // Calculate elapsed time in seconds

            if (isNaN(elapsedTime)) return; // Check for invalid values

            const remainingTime = Math.max(durationInMinutes * 60 - elapsedTime, 0); // Ensure time doesn't go below 0

            setTimeLeft(remainingTime); // Update the remaining time
        }, 1000);

        // Cleanup interval when the component unmounts or when startTime changes
        return () => clearInterval(timerId);
    }, [startTime, durationInMinutes]);

    useEffect(() => {
        if (timeLeft === 0) {
            handleSubmit();           
        }
    }, [timeLeft]);
    useEffect(() => {
        if (mockTest_id) {
            getAllQuestionsById(mockTest_id);
        }
    }, [mockTest_id, package_id]);
    const handleOpenModal = () => {
        const subData = {
            ...subjectProgress,
            [selectedSubjectId]: allQuestions
        }

        setSubjectProgress(subData);

        const combinedQuestions = Object.values(subData).flat();

        // Map through combined questions and update answers for submission
        const updatedSubjectQuestionsById = subjectQuestionsById.map(subjectQuestion => {

            const correspondingUserQuestion = combinedQuestions.find(q => q.questionId === subjectQuestion.questionId);

            if (correspondingUserQuestion) {
                // For Comprehensive and Poem types                    
                if (subjectQuestion.type === 'Comprehensive' || subjectQuestion.type === 'Poem') {
                    const updatedSubQuestions = subjectQuestion.questions.map(subQ => {
                        const userSubQuestion = correspondingUserQuestion.questions.find(sq => sq.questionId === subQ.questionId);
                        return {
                            ...subQ,
                            answer: userSubQuestion?.answer !== null ? userSubQuestion.answer : null,
                            status: userSubQuestion?.answer !== null ? 'answered' : 'skipped'
                        };
                    });

                    return { ...subjectQuestion, questions: updatedSubQuestions };
                }
                // For General type
                else if (subjectQuestion.type === 'General') {

                    return {
                        ...subjectQuestion,
                        answer: correspondingUserQuestion?.answer !== null ? correspondingUserQuestion.answer : null,
                        status: correspondingUserQuestion?.answer !== null ? 'answered' : 'skipped'
                    };
                }
            }

            return subjectQuestion; // Keep unchanged if no corresponding question
        });

        // Prepare subject data for submission
        const subjectData = subjects.map(subject => ({
            subjectId: subject.subjectId,
            numberOfQuestions: subject.numberOfQuestions
        }));

        // Prepare submitted answers, including skipped ones (set as -1)
        const submittedAnswers = updatedSubjectQuestionsById.flatMap(question => {
            if (question.type === 'Comprehensive' || question.type === 'Poem') {
                return question.questions.map(subQuestion => ({
                    question_id: question.questionId,
                    sub_question_id: subQuestion.questionId,
                    selectedOption: subQuestion.answer !== null
                        ? subQuestion.options.indexOf(subQuestion.answer)
                        : -1, // Mark as -1 if no answer
                    typeOfQuestion: question.type
                }));
            } else if (question.type === 'General') {
                return {
                    question_id: question.questionId,
                    selectedOption: question.answer !== null
                        ? question.options.indexOf(question.answer)
                        : -1, // Mark as -1 if no answer
                    typeOfQuestion: question.type
                };
            }
            return [];
        });

        // Calculate submitted and not submitted counts from submittedAnswers
        const submittedCount = submittedAnswers.filter(answer => answer.selectedOption !== -1).length;
        const notSubmittedCount = submittedAnswers.length - submittedCount;

        setAttemptedCount(submittedCount);
        setNotAttemptedCount(notSubmittedCount);
        setIsModalOpen(true)
    };

    const handleCloseModal = () => setIsModalOpen(false);

    const handleConfirmSubmit = () => { 
        setIsModalOpen(false);
        handleSubmit();
    };


    function setSubjectsDataToDisplay(subjectQuestions, subjects, subjectId) {
        const formattedQuestions = subjectQuestions.flatMap(subject => subject.questions.map(question => {
            if (question.typeOfQuestion === 'Comprehensive') {
                return {
                    subjectId: subject.subjectId, // Add subjectId to each question
                    type: 'Comprehensive',
                    questionId: question.questionId, // Include questionId
                    paragraph: question.question,
                    questions: question.subQuestions.map(subQuestion => ({
                        questionId: subQuestion.subQuestionId,
                        question: subQuestion.question,
                        options: subQuestion.options,
                        answer: null,
                        status: 'unanswered'
                    }))
                };
            } else if (question.typeOfQuestion === 'Poem') {
                return {
                    subjectId: subject.subjectId, // Add subjectId to each question
                    type: 'Poem',
                    questionId: question.questionId, // Include questionId
                    paragraph: question.question,
                    questions: question.subQuestions.map(subQuestion => ({
                        questionId: subQuestion.subQuestionId,
                        question: subQuestion.question,
                        options: subQuestion.options,
                        answer: null,
                        status: 'unanswered'
                    }))
                };
            } else if (question.typeOfQuestion === 'General') {
                return {
                    subjectId: subject.subjectId, // Add subjectId to each question
                    type: 'General',
                    questionId: question.questionId,
                    question: question.question,
                    options: question.options,
                    answer: null,
                    status: 'unanswered'
                };
            } else {
                return null;
            }
        })
        ).filter(q => q !== null);

        setSubjects(subjects);
        setSubjectQuestionsById(formattedQuestions);
        const filteredQuestions = formattedQuestions.filter(question => question.subjectId === subjectId);

        setAllQuestions(filteredQuestions);

        if (subjectId) {

            const existingAnswers = subjectAnswers[subjectId] || [];

            setAllQuestions(prevQuestions => prevQuestions.map(q => {
                if (q.type === 'Comprehensive' || q.type === 'Poem') {
                    const questionAnswers = existingAnswers.find(a => a.question_id === q.questionId);
                    if (questionAnswers) {
                        q.questions.forEach(subQ => {
                            const subQAnswer = questionAnswers.selectedOption.find(sa => sa.subQuestion_id === subQ.questionId);
                            if (subQAnswer) {
                                subQ.answer = subQ.options[subQAnswer.selectedOption];
                                subQ.status = subQAnswer.selectedOption !== undefined ? 'answered' : 'skipped';
                            }
                        });
                    }
                } else if (q.type === 'General') {
                    const questionAnswer = existingAnswers.find(a => a.question_id === q.questionId);
                    if (questionAnswer) {
                        q.answer = q.options[questionAnswer.selectedOption];
                        q.status = questionAnswer.selectedOption !== undefined ? 'answered' : 'skipped';
                    }
                }
                return q;
            }));

        }
    }

    const getAllQuestionsById = async (mockTest_id, subjectId = null) => {
        setLoading(true);
        try {
            const response = await StudentDashboardServices.getAllQuestionsById(mockTest_id, subjectId);
            setAllData(response.data);

            const { subjectQuestions, subjects } = response.data;

            var selectedSubjectDataId = subjectId;
            // If no subjectId is provided and there are subjects available, select the first subject as default
            if (subjectId === null && subjects.length > 0) {
                const defaultSubject = subjects[0];
                setSelectedSubjectId(defaultSubject.subjectId);
                setActiveTab(defaultSubject.subjectName);
                selectedSubjectDataId = defaultSubject.subjectId;
                // return getAllQuestionsById(mockTest_id, defaultSubject.subjectId);
            }

            // Processing questions and formatting them
            setSubjectsDataToDisplay(subjectQuestions, subjects, selectedSubjectDataId);

        } catch (error) {
            console.error("Error fetching questions:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleSubjectChange = (subjectId, subjectName) => {
        // Update the status of the current question before changing the subject
        const updatedQuestions = allQuestions.map((item, index) => {

            if ((item.type === "Comprehensive" || item.type === "Poem") && index === currentQuestionIndex) {
                const updatedSubQuestions = item.questions.map(subQuestion => {
                    if (subQuestion.status === "unanswered" && subQuestion.answer == null) {
                        return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
                    }
                    return subQuestion;
                });
                return { ...item, questions: updatedSubQuestions };
            }
            if (index === currentQuestionIndex && item.status === "unanswered" && item.answer == null) {
                return { ...item, status: "skipped" }; // Mark as skipped
            }
            return item;
        });


        // Save progress with updated questions before changing subject
        saveSubjectProgress(selectedSubjectId, updatedQuestions);

        if (subjectId === selectedSubjectId) {
            return; // Do not reset or change anything if it's the same subject
        }

        // Load saved progress or fetch new questions for the new subject
        const savedProgress = subjectProgress[subjectId];
        if (savedProgress) {
            setAllQuestions(savedProgress);
        } else {
            const { subjectQuestions, subjects } = alldata;

            setSubjectsDataToDisplay(subjectQuestions, subjects, subjectId);
            // getAllQuestionsById(mockTest_id, subjectId);
        }
        // Merge the new subject progress with the existing subject progress
        const updatedSubjectProgress = {
            ...subjectProgress, // Keep the previous subjects' progress
            [selectedSubjectId]: updatedQuestions // Add the current subject's progress before switching
        };
        setSubjectProgress(updatedSubjectProgress); // Update the subjectProgress state with the merged progress


        // Set the active tab and update other states
        setActiveTab(subjectName);
        setSelectedSubjectId(subjectId);
        setCurrentQuestionIndex(0);
    };

    // save the progress of the current subject
    const saveSubjectProgress = (subjectId, questions) => {
        setSubjectProgress(prevProgress => ({
            ...prevProgress,
            [subjectId]: questions
        }));
    };

    const handleSubmit = async () => {
        setLoadingTwo(true)
        try {
            const endTime = new Date().toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour12: true });
            const startFormattedTime  = startTime.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour12: true });
            const timeTakenInSeconds = initialTime - timeLeft;
            const hours = Math.floor(timeTakenInSeconds / 3600);
            const minutes = Math.floor((timeTakenInSeconds % 3600) / 60);
            const seconds = timeTakenInSeconds % 60;

            const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            const submittedDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata", hour12: true });
            // Save progress for the current subject
            // saveSubjectProgress(selectedSubjectId, allQuestions);
            // Combine all subjects' progress before submitting

            const subData = {
                ...subjectProgress,
                [selectedSubjectId]: allQuestions
            }

            setSubjectProgress(subData);

            const combinedQuestions = Object.values(subData).flat();

            // Map through combined questions and update answers for submission
            const updatedSubjectQuestionsById = subjectQuestionsById.map(subjectQuestion => {

                const correspondingUserQuestion = combinedQuestions.find(q => q.questionId === subjectQuestion.questionId);

                if (correspondingUserQuestion) {
                    // For Comprehensive and Poem types                    
                    if (subjectQuestion.type === 'Comprehensive' || subjectQuestion.type === 'Poem') {
                        const updatedSubQuestions = subjectQuestion.questions.map(subQ => {
                            const userSubQuestion = correspondingUserQuestion.questions.find(sq => sq.questionId === subQ.questionId);
                            return {
                                ...subQ,
                                answer: userSubQuestion?.answer !== null ? userSubQuestion.answer : null,
                                status: userSubQuestion?.answer !== null ? 'answered' : 'skipped'
                            };
                        });

                        return { ...subjectQuestion, questions: updatedSubQuestions };
                    }
                    // For General type
                    else if (subjectQuestion.type === 'General') {

                        return {
                            ...subjectQuestion,
                            answer: correspondingUserQuestion?.answer !== null ? correspondingUserQuestion.answer : null,
                            status: correspondingUserQuestion?.answer !== null ? 'answered' : 'skipped'
                        };
                    }
                }

                return subjectQuestion; // Keep unchanged if no corresponding question
            });

            // Prepare subject data for submission
            const subjectData = subjects.map(subject => ({
                subjectId: subject.subjectId,
                numberOfQuestions: subject.numberOfQuestions
            }));

            // Prepare submitted answers, including skipped ones (set as -1)
            const submittedAnswers = updatedSubjectQuestionsById.flatMap(question => {
                if (question.type === 'Comprehensive' || question.type === 'Poem') {
                    return question.questions.map(subQuestion => ({
                        question_id: question.questionId,
                        sub_question_id: subQuestion.questionId,
                        selectedOption: subQuestion.answer !== null
                            ? subQuestion.options.indexOf(subQuestion.answer)
                            : -1, // Mark as -1 if no answer
                        typeOfQuestion: question.type
                    }));
                } else if (question.type === 'General') {
                    return {
                        question_id: question.questionId,
                        selectedOption: question.answer !== null
                            ? question.options.indexOf(question.answer)
                            : -1, // Mark as -1 if no answer
                        typeOfQuestion: question.type
                    };
                }
                return [];
            });

            // Calculate submitted and not submitted counts from submittedAnswers
            // const submittedCount = submittedAnswers.filter(answer => answer.selectedOption !== -1).length;
            // const notSubmittedCount = submittedAnswers.length - submittedCount;
            // handleOpenModal(submittedCount, notSubmittedCount)
            // setIsModalOpen(true);
            // window.confirm(`Submitted Questions: ${submittedCount}\nNot Submitted Questions: ${notSubmittedCount}`);

            const response = await StudentDashboardServices.submitTest(
                mockTestData.order_id,
                mockTest_id,
                package_id,
                formattedTime,
                submittedAnswers,
                subjectData,
                startFormattedTime,
                endTime,
                submittedDate
            );
            setLoadingTwo(false);
            toast.success(response.message);
            setIsSubmitted(true)
            // navigate(RoutesPath.mymocktest);

        } catch (error) {
            setLoadingTwo(false);
            handleApiErrors(error);
            toast.error("Failed to submit test. Please try again later.");
        }
    };

    const handleOptionChange = (questionIndex, option, subQuestionIndex = null) => {
        setAllQuestions(prevQuestions => {
            const updatedQuestions = [...prevQuestions];
            const currentQuestion = updatedQuestions[questionIndex];

            if ((currentQuestion.type === 'Comprehensive' || currentQuestion.type === 'Poem') && subQuestionIndex !== null) {
                const updatedSubQuestion = currentQuestion.questions[subQuestionIndex];
                updatedSubQuestion.answer = updatedSubQuestion.answer === option ? null : option;
                updatedSubQuestion.status = updatedSubQuestion.answer === null ? "skipped" : "answered";
                updatedQuestions[questionIndex].questions[subQuestionIndex] = updatedSubQuestion;
            } else {
                currentQuestion.answer = currentQuestion.answer === option ? null : option;
                currentQuestion.status = currentQuestion.answer === null ? "skipped" : "answered";
            }

            saveSubjectProgress(selectedSubjectId, updatedQuestions);
            return updatedQuestions;
        });
    };

    const formatTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return { hrs, mins, secs };
    };

    const { hrs, mins, secs } = formatTime(timeLeft);



    const handleNextQuestion = () => {
        scrollToTop();
        // Update the status of the current question before moving to the next one
        const updatedQuestions = allQuestions.map((item, index) => {
            if ((item.type === "Comprehensive" || item.type === "Poem") && index === currentQuestionIndex) {
                const updatedSubQuestions = item.questions.map(subQuestion => {
                    if (subQuestion.status === "unanswered" && subQuestion.answer == null) {
                        return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
                    }
                    return subQuestion;
                });
                return { ...item, questions: updatedSubQuestions };
            }
            if (index === currentQuestionIndex && item.status === "unanswered" && item.answer == null) {
                return { ...item, status: "skipped" }; // Mark as skipped
            }
            return item;
        });


        setAllQuestions(updatedQuestions);

        // Move to the next question or subject
        if (currentQuestionIndex < allQuestions.length - 1) {
            setCurrentQuestionIndex(prevIndex => {
                const newIndex = prevIndex + 1;
                return newIndex;
            });
        } else {
            const currentSubjectIndex = subjects.findIndex(subject => subject.subjectId === selectedSubjectId);
            const nextSubjectIndex = currentSubjectIndex + 1;

            if (nextSubjectIndex < subjects.length) {
                saveSubjectProgress(selectedSubjectId, updatedQuestions); // Save updated questions status       
                const nextSubject = subjects[nextSubjectIndex];
                handleSubjectChange(nextSubject.subjectId, nextSubject.subjectName);

            } else {
                toast.info("You have completed all subjects.");
            }
        }
    };

    const handlePreviousQuestion = () => {
        scrollToTop();
        if (currentQuestionIndex > 0 || !isFirstQuestionOfSubject()) {
            const isFirstQuestion = currentQuestionIndex === 0;
            const isFirstSubject = subjects.length > 0 && selectedSubjectId === subjects[0].subjectId;

            if (isFirstQuestion && !isFirstSubject) {
                // Move to the previous subject
                const currentSubjectIndex = subjects.findIndex(subject => subject.subjectId === selectedSubjectId);
                if (currentSubjectIndex > 0) {
                    const prevSubject = subjects[currentSubjectIndex - 1];
                    handleSubjectChange(prevSubject.subjectId, prevSubject.subjectName);

                    // Set to the last question of the previous subject
                    const prevQuestions = subjectProgress[prevSubject.subjectId] || [];
                    setCurrentQuestionIndex(prevQuestions.length - 1); // Move to the last question

                }
            } else {
                // Move to the previous question in the same subject
                const updatedQuestions = allQuestions.map((item, index) => {
                    if ((item.type === "Comprehensive" || item.type === "Poem") && index === currentQuestionIndex) {
                        const updatedSubQuestions = item.questions.map(subQuestion => {
                            if (subQuestion.status === "unanswered" && subQuestion.answer == null) {
                                return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
                            }
                            return subQuestion;
                        });
                        return { ...item, questions: updatedSubQuestions };
                    }

                    if (index === currentQuestionIndex && item.status === "unanswered" && item.answer == null) {
                        return { ...item, status: "skipped" }; // Update the status to 'skipped'
                    }

                    return item;
                });
                setAllQuestions(updatedQuestions);
                setCurrentQuestionIndex(prevIndex => {
                    const newIndex = Math.max(prevIndex - 1, 0);

                    return newIndex;
                });
            }
        }
    };
    const isFirstQuestionOfSubject = () => {
        return currentQuestionIndex === 0 && subjects.length > 0 && selectedSubjectId === subjects[0].subjectId;
    };


    const isPreviousButtonDisabled = () => {
        const isFirstQuestion = currentQuestionIndex === 0;
        const isFirstSubject = subjects.length > 0 && selectedSubjectId === subjects[0]?.subjectId;
        const isLastSubjectFirstQuestion = subjects.length > 0 && selectedSubjectId === subjects[subjects.length - 1].subjectId && currentQuestionIndex === 0;

        return isFirstQuestion && isFirstSubject && !isLastSubjectFirstQuestion;
    };
    const handleQuestionBoxClick = (qIndex) => {
        // Only update the status if the selected question is different from the current question
        if (qIndex !== currentQuestionIndex) {
            // Update the status of the current question before moving to the selected one
            const updatedQuestions = allQuestions.map((item, index) => {
                if ((item.type === "Comprehensive" || item.type === "Poem") && index === currentQuestionIndex) {
                    const updatedSubQuestions = item.questions.map(subQuestion => {
                        if (subQuestion.status === "unanswered" && subQuestion.answer == null) {
                            return { ...subQuestion, status: "skipped" }; // Mark as skipped if unanswered
                        }
                        return subQuestion;
                    });
                    return { ...item, questions: updatedSubQuestions };
                }

                if (index === currentQuestionIndex && item.status === "unanswered" && item.answer == null) {
                    return { ...item, status: "skipped" }; // Mark as skipped
                }
                return item;
            });
            setAllQuestions(updatedQuestions);
        }

        // Set the current question index to the selected question box
        setCurrentQuestionIndex(qIndex);
    };

    const currentQuestion = allQuestions[currentQuestionIndex];

    const isComprehensiveAnswered = (question) => {
        return question.questions.every(subQuestion => subQuestion.answer !== null);
    };
    const isComprehensiveSkipped = (question) => {
        return question.questions.some(subQuestion => subQuestion.status === 'skipped');
    };
    const getAlphabetLabel = (index) => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        return letters[index] || "";
    };
    const decodeHtml = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.documentElement.innerHTML;
    };
    const decodeHtmlopt = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.documentElement.textContent;
    };
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = ''; // This triggers the confirmation dialog
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload); // Cleanup when component unmounts
        };
    }, []);
    // useEffect(() => {
    //     // Push a new state to the browser history stack
    //     window.history.pushState(null, null, window.location.href);

    //     const handleBackButton = (e) => {
    //         // This will be called when the back button is pressed
    //         e.preventDefault();
    //         alert('Back button is disabled during the test.');
    //         // You can also push a new state to "cancel" the back action
    //         window.history.pushState(null, null, window.location.href);
    //     };

    //     window.addEventListener('popstate', handleBackButton);

    //     return () => {
    //         // Cleanup when the component unmounts
    //         window.removeEventListener('popstate', handleBackButton);
    //     };
    // }, []);

    const customParser = (node) => {
        if (node.name === "oembed") {
            const url = node.attribs.url;
            let videoId;
            // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
            if (url.includes("youtube.com")) {
                videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
            } else if (url.includes("youtu.be")) {
                videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
            }
            if (videoId) {
                return (
                    <iframe
                        width="560"
                        height="315"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="YouTube video"
                    />
                );
            } else {
                return <p className='text-danger'>Invalid YouTube URL</p>;
            }
        }
    };

    const cleanQuestionText = (text) => {
        return text.replace(/&nbsp;/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const getCurrentQuestionNumber = () => {
        // Get base number from previous subjects
        const baseNumber = subjects
            .slice(0, subjects.findIndex(s => s.subjectId === selectedSubjectId))
            .reduce((total, subject) => {
                const subjectQuestions = subjectQuestionsById.filter(q => q.subjectId === subject.subjectId);
                return total + subjectQuestions.reduce((count, q) => {
                    if (q.type === 'Comprehensive' || q.type === 'Poem') {
                        return count + q.questions.length;
                    }
                    return count + 1;
                }, 0);
            }, 0);

        // Count questions up to current index in current subject
        let currentSubjectCount = 0;
        const currentSubjectQuestions = allQuestions.slice(0, currentQuestionIndex + 1);

        for (let i = 0; i < currentSubjectQuestions.length - 1; i++) {
            const q = currentSubjectQuestions[i];
            if (q.type === 'Comprehensive' || q.type === 'Poem') {
                currentSubjectCount += q.questions.length;
            } else {
                currentSubjectCount += 1;
            }
        }

        // Add count for current question's previous sub-questions
        const currentQuestion = currentSubjectQuestions[currentSubjectQuestions.length - 1];
        if (currentQuestion?.type === 'Comprehensive' || currentQuestion?.type === 'Poem') {
            currentSubjectCount += 1; // Add one for the current sub-question being displayed
        } else {
            currentSubjectCount += 1;
        }

        return baseNumber + currentSubjectCount;
    };

    const scrollToTop = () => {
        document.getElementById("scroll_bar").scroll(0,0)
      }
    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar bg-white"id='scroll_bar'>
                    {
                        isSubmitted ? (
                            <div className="text-center">
                                <div className="no-record-image">
                                    <Image src={PngImages.examsubmitpic} className="img-fluid" />
                                </div>
                                <p className="no-records-text Small-Heading fw-700 mb-4" style={{ color: "#368C36" }}>Exam Submitted Successfully!</p>
                                <div className="d-flex justify-content-center">
                                    <Link to={RoutesPath.mymocktest}>
                                        <SubmitButtonTwo title={"Go to Mocktest"} className="Package-button mb-4" />
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            <div className="mb-3 justify-content-between align-items-center">
                                <h1 className="black sub-large-text-one fw-700">{alldata.mockTestName}</h1>

                                <div className="my-4 row">
                                    <div className='col-md-12 col-lg-7 col-xl-8 col-xxl-9 '>
                                        <ul className="small-medium-text overflow-auto fw-600 list-group list-group-horizontal gap-1 mb-4 text-white">
                                            {subjects.map(subject => (
                                                <li
                                                    key={subject.subjectId}
                                                    className={`list-group-item border-0 ${activeTab === subject.subjectName ? 'active' : ''}`}
                                                    onClick={() => handleSubjectChange(subject.subjectId, subject.subjectName)}
                                                    style={{ cursor: 'pointer', borderRadius: "6px", backgroundColor: activeTab === subject.subjectName ? '#F6821F' : 'transparent' }}
                                                >
                                                    {subject.subjectName}
                                                </li>
                                            ))}
                                        </ul>

                                        <div className="small-medium-text fw-600 hrline2" style={{ color: '#14489F' }}>
                                            <p className="">Question {getCurrentQuestionNumber()}</p>
                                        </div>

                                        <section className='small-medium-text my-4'>
                                            {loading ? (
                                                <div className="text-center d-flex justify-content-center">
                                                    <CirclesWithBar
                                                        height="80"
                                                        width="80"
                                                        color="#F6821F"
                                                        ariaLabel="bars-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClass=""
                                                    />
                                                </div>
                                            ) : (
                                                <>

                                                    {(currentQuestion?.type === 'Comprehensive' || currentQuestion?.type === 'Poem') && (
                                                        <div>
                                                            {/* <div className='small-medium-text fw-600'>Read Carefully</div> */}

                                                            {currentQuestion?.type === 'Poem' || 'Comprehensive' ? (

                                                                <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                    {cleanQuestionText(currentQuestion?.paragraph) && parse(cleanQuestionText(currentQuestion.paragraph), { replace: customParser })}
                                                                </div>

                                                            ) : (
                                                                null
                                                            )}
                                                            <div className="my-4 hrline2">
                                                                {currentQuestion?.questions?.map((q, index) => (
                                                                    <div key={index} className='my-4'>
                                                                        {/* <div className="small-medium-text fw-600 text-dark mb-3">
                                                                        <span>{index + 1}. </span>{decodeHtmlopt(q.question.replace(/&nbsp;/g, ' '))}
                                                                    </div> */}
                                                                        <div className="small-medium-text fw-600 text-dark d-flex align-items-center gap-2 mb-3">
                                                                            <div style={{ marginBottom: '9px' }}>{index + 1}. </div>

                                                                            {currentQuestion?.type === 'Poem' || 'Comprehensive' ? (

                                                                                <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                                    {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}
                                                                                </div>

                                                                            ) : (
                                                                                null
                                                                            )}

                                                                        </div>
                                                                        <ol className="list-group">
                                                                            {q.options?.map((option, optIndex) => (
                                                                                <li key={optIndex} className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0">
                                                                                    <div className="ms-2 me-auto form-check cursor-pointer">
                                                                                        <input
                                                                                            className='form-check-input border-2 '
                                                                                            type="checkbox"
                                                                                            style={{ boxShadow: "none" }}
                                                                                            checked={q.answer === option}
                                                                                            onChange={() => handleOptionChange(currentQuestionIndex, option, index)}
                                                                                            id={`Comprehensive-option-${index}-${optIndex}`}
                                                                                        />
                                                                                        <label className="form-check-label small-medium-text fw-500 px-1 cursor-pointer" htmlFor={`Comprehensive-option-${index}-${optIndex}`}>
                                                                                            <div className="d-flex gap-2">
                                                                                                <span style={{ marginTop: '2px' }}>{getAlphabetLabel(optIndex)}. </span> <span>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</span>
                                                                                            </div>
                                                                                        </label>
                                                                                    </div>
                                                                                </li>
                                                                            ))}
                                                                        </ol>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {currentQuestion?.type === 'General' && (
                                                        <div>
                                                            {currentQuestion?.type === 'General' ? (

                                                                <div className="w-100 small-medium-text fw-600 blog-data-html" style={{ contain: "content" }}>
                                                                    {cleanQuestionText(currentQuestion?.question) && parse(cleanQuestionText(currentQuestion.question), { replace: customParser })}
                                                                </div>

                                                            ) : (
                                                                null
                                                            )}
                                                            <ol className="list-group mt-2 mb-4 hrline2">
                                                                {currentQuestion?.options?.map((option, optIndex) => (
                                                                    <li key={optIndex} className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0">
                                                                        <div className="ms-2 me-auto form-check cursor-pointer">
                                                                            <input
                                                                                className='form-check-input border-2'
                                                                                type="checkbox"
                                                                                style={{ boxShadow: "none" }}
                                                                                checked={currentQuestion?.answer === option}
                                                                                onChange={() => handleOptionChange(currentQuestionIndex, option)}
                                                                                id={`General-option-${optIndex}`}
                                                                            />
                                                                            <label className="form-check-label small-medium-text fw-500 px-1 cursor-pointer" htmlFor={`General-option-${optIndex}`}>
                                                                                <div className="d-flex gap-2">
                                                                                    <span style={{ marginTop: '2px' }}>{getAlphabetLabel(optIndex)}. </span> <p>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</p>
                                                                                </div>
                                                                            </label>
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                            </ol>
                                                        </div>
                                                    )}

                                                    < div className="d-flex flex-wrap justify-content-between align-items-center small-medium-text fw-400 px-2 gap-2">
                                                        <SubmitButtonTwo title={'Previous'}
                                                            className="previewbtn"
                                                            onclick={handlePreviousQuestion}
                                                            disabled={isPreviousButtonDisabled()}

                                                        >

                                                        </SubmitButtonTwo>
                                                        <div className="d-flex gap-3 ">
                                                            {/* {!(currentQuestionIndex === allQuestions.length - 1 && subjects.length > 0 && selectedSubjectId === subjects[subjects.length - 1].subjectId) && ( */}

                                                            <SubmitButtonTwo
                                                                className="nextbtn"
                                                                title={'Next'}
                                                                onclick={handleNextQuestion}
                                                            // disabled={currentQuestionIndex > subjectQuestionsById.length - 1}

                                                            >

                                                            </SubmitButtonTwo>

                                                            {/* )} */}

                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </section>
                                    </div>

                                    <div className='col-md-12 col-lg-5 col-xl-4 col-xxl-3' style={{ backgroundColor: '#f3f5f6', borderRadius: "20px" }}>
                                        <div className='timerdiv medium-text fw-500 p-4 mx-2' style={{ backgroundColor: '#14489F', borderRadius: "20px" }}>
                                            <p className='text-start respo-timelft align-items-center justify-content-center'>
                                                <Image src={Vector} alt="Timer Icon" className="fw-500 pb-1 me-1" /> Time Left
                                            </p>
                                            <div className='d-flex gap-3 respo-timelft justify-content-start text-start gap-3'>
                                                <div className='hours'>
                                                    <span className='medium-text fw-600'>{hrs.toString().padStart(2, '0')}</span>
                                                    <div className='medium-text fw-400 pt-3'>Hours</div>
                                                </div>
                                                <div className='minutes'>
                                                    <span className='medium-text fw-600'>{mins.toString().padStart(2, '0')}</span>
                                                    <div className='medium-text fw-400 pt-3'>Minutes</div>
                                                </div>
                                                <div className='seconds'>
                                                    <span className='medium-text fw-600'>{secs.toString().padStart(2, '0')}</span>
                                                    <div className='medium-text fw-400 pt-3'>Seconds</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="questions-container hrline2 pb-4">
                                            {(() => {
                                                // Calculate the starting number based on questions in previous subjects
                                                const startingNumber = subjects
                                                    .slice(0, subjects.findIndex(s => s.subjectId === selectedSubjectId))
                                                    .reduce((total, subject) => {
                                                        // Find questions for this subject
                                                        const subjectQuestions = subjectQuestionsById.filter(q => q.subjectId === subject.subjectId);

                                                        // Count total questions (including subquestions)
                                                        return total + subjectQuestions.reduce((count, q) => {
                                                            if (q.type === 'Comprehensive' || q.type === 'Poem') {
                                                                return count + q.questions.length; // Count subquestions
                                                            }
                                                            return count + 1; // Count general question
                                                        }, 0);
                                                    }, 1); // Start from 1

                                                let questionNumber = startingNumber; // Initialize counter with calculated starting number

                                                return allQuestions
                                                    .filter(question => question.subjectId === selectedSubjectId)
                                                    .map((question, qIndex) => {
                                                        if (question.type === 'Comprehensive' || question.type === 'Poem') {
                                                            return (
                                                                <React.Fragment key={qIndex}>
                                                                    {question.questions.map((subQuestion, subIndex) => (
                                                                        <div
                                                                            key={`${qIndex}-${subIndex}`}
                                                                            className={`question-box ${subQuestion.answer ? 'bg-green'
                                                                                : subQuestion.status === 'skipped' ? 'bg-yellow'
                                                                                    : 'bg-grey'
                                                                                }`}
                                                                            onClick={() => handleQuestionBoxClick(qIndex)}
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {questionNumber++}
                                                                        </div>
                                                                    ))}
                                                                </React.Fragment>
                                                            );
                                                        } else {
                                                            // For General questions
                                                            return (
                                                                <div
                                                                    key={qIndex}
                                                                    className={`question-box ${question.status === 'answered' ? 'bg-green'
                                                                        : question.status === 'skipped' ? 'bg-yellow'
                                                                            : 'bg-grey'
                                                                        }`}
                                                                    onClick={() => handleQuestionBoxClick(qIndex)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {questionNumber++}
                                                                </div>
                                                            );
                                                        }
                                                    });
                                            })()}
                                        </div>

                                        <div className='container m-4 d-grid gap-3'>
                                            <div className='d-flex justify-content-start align-items-center gap-3 small-medium-text'><span className='bg-green answercircle'></span>Answered</div>
                                            <div className='d-flex justify-content-start align-items-center gap-3 small-medium-text'><span className='bg-yellow answercircle'></span>Not Answered</div>
                                            <div className='d-flex justify-content-start align-items-center gap-3 small-medium-text'><span className='bg-grey answercircle'></span>Not Viewed</div>
                                        </div>


                                        <div className='d-flex justify-content-end mb-4'>
                                            {loadingTwo ? (
                                                <div className="text-center d-flex justify-content-center">
                                                    <RotatingLines
                                                        height="25"
                                                        width="25"
                                                        strokeColor="#F6821F"
                                                        ariaLabel="bars-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClass=""
                                                    />
                                                </div>
                                            ) : (
                                                <SubmitButtonTwo
                                                    className="submitbtn"
                                                    title={'Submit Test'}
                                                    onclick={handleOpenModal}
                                                />

                                            )}
                                        </div>
                                        {isModalOpen && (
                                            <div className="modal-overlay-custom">
                                                <div className="modal-content-custom">
                                                    <div className="modal-header p-0 mb-3 d-flex justify-content-end" style={{ borderBottom: 'none' }}>
                                                        {/* <h2 className="medium-text fw-600  mb-0" style={{ fontStyle: 'italic', color: '#FF0000' }}>{title}</h2> */}
                                                        <Image className="cursor-pointer " src={PngImages.redcross} style={{ aspectRatio: 1 }} onClick={() => handleCloseModal(false)} />
                                                    </div>
                                                    <div className='d-flex justify-content-between'>
                                                        <h3 className='large-text fw-600'>Are you sure?</h3>
                                                        <p className="blue fw-600 text-undeline-custom">
                                                            {hrs.toString().padStart(2, '0')} hr {mins.toString().padStart(2, '0')} mins {secs.toString().padStart(2, '0')} secs left
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <div className='d-flex gap-1 align-items-center p-3 custom-modal-bg-green border-radius-10'>
                                                            <div className='custom-modal-text-green small-medium-text fw-600'>No. of attempted questions :</div>
                                                            <div className='small-medium-text custom-modal-text-green fw-600'>{attemptedCount}</div>
                                                        </div>
                                                        <div className='d-flex mt-2 p-3 gap-1 align-items-center custom-modal-bg-red border-radius-10'>
                                                            <div className='custom-modal-text-red small-medium-text fw-600'>Not attempted questions :</div>
                                                            <div className='small-medium-text custom-modal-text-red fw-600'>{notAttemptedCount}</div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-2 mt-5 justify-content-center">
                                                        <SubmitButtonTwo className="nobutton cursor-pointer custom-width-50" title={'No'} onclick={handleCloseModal} />
                                                        <SubmitButtonTwo className="yesbutton cursor-pointer custom-width-50" title={'Yes'} onclick={handleConfirmSubmit} />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    }

                </div>
            </div >
        </div >
    );
};

export default Mocktest;
